import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { ImageModelPropTypes } from '@bingads-webui-campaign/image-experience-proptypes';
import { AdPlacementCardPreview } from './ad-placement-card-preview';

export class AdPlacementPreview extends React.PureComponent {
  render() {
    const containerOpacity = !this.props.opacityChangeEnabled || this.props.image.IsIncluded ? '100%' : '50%';
    const cardProps = _.pick(
      this.props,
      'image',
      'previewTexts',
      'i18n',
      'showShortHeadline',
      'showLongHeadline',
      'showDescription',
      'showGradient',
      'previewContentClassName',
      'additionalSetting',
      'showBusinessName',
      'multipleDescription',
      'multipleLineLongHeadline',
      'hideLabel',
      'showUrl',
      'showAction',
      'showAdsLabel',
      'showAdsIcon',
      'dismissText',
      'showHotspots',
      'showImage',
      'hotspots',
      'showLogo',
      'logo',
      'isMultimediaAd',
      'isMultiMediaAdsPhase2Enabled',
      'isAdCreatorEnabled'
    );

    return (
      <div className="new-responsive-ad-preview-container" style={{ opacity: containerOpacity }}>
        <AdPlacementCardPreview {...cardProps} />
        <div className="preview-type-string">
          {this.props.i18n.getString(this.props.additionalSetting.previewTypeStringKey)}
        </div>
        {this.props.children}
      </div>
    );
  }
}

AdPlacementPreview.propTypes = {
  image: ImageModelPropTypes.isRequired,
  previewTexts: PropTypes.shape({
    shortHeadline: PropTypes.string,
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
    url: PropTypes.string,
    callToAction: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showShortHeadline: PropTypes.bool,
  showLongHeadline: PropTypes.bool,
  showDescription: PropTypes.bool,
  showGradient: PropTypes.bool,
  previewContentClassName: PropTypes.string.isRequired,
  showBusinessName: PropTypes.bool,
  showUrl: PropTypes.bool,
  showAction: PropTypes.bool,
  opacityChangeEnabled: PropTypes.bool,
  showAdsLabel: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  isMultiMediaAdsPhase2Enabled: PropTypes.bool,
  isAdCreatorEnabled: PropTypes.bool,
  additionalSetting: PropTypes.shape({
    previewTypeStringKey: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

AdPlacementPreview.defaultProps = {
  showShortHeadline: false,
  opacityChangeEnabled: false,
  showLongHeadline: false,
  showDescription: false,
  showGradient: false,
  showBusinessName: true,
  showUrl: false,
  showAction: false,
  showAdsLabel: false,
  isMultimediaAd: false,
  isMultiMediaAdsPhase2Enabled: false,
  isAdCreatorEnabled: false,
  children: null,
};
